module.exports = __webpack_public_path__ + "img/imageedit102627581546.095f96df.png";